import { FiAward, FiExternalLink } from "react-icons/fi";
import { SiLeetcode } from "react-icons/si";

import BadgeCard from "../components/ui/BadgeCard";
import LeetCodeBadge from "../components/ui/LeetCodeBadge";
import certificates from "../data/certificates";
import { profile } from "../data/profile";
import { useLeetCode } from "../lib/leetcode";

const Badges = () => {
  const { data, loading, error } = useLeetCode(
    "badges",
    profile.leetcodeUsername
  );
  const lcBadges = data?.badges || [];
  const lcCount = data?.badgesCount ?? lcBadges.length;
  const profileUrl = `https://leetcode.com/u/${profile.leetcodeUsername}/`;

  return (
    <div className="page badges-page">
      <div className="page-head">
        <h1 className="page-title">
          Badges <span className="page-title-alt">/ Certificates</span>
        </h1>
        <span className="page-sub">
          {certificates.length} certificates
          {lcCount ? ` · ${lcCount} LeetCode badges` : ""}
        </span>
      </div>

      <section className="lc-badges-section">
        <div className="section-head">
          <h2 className="section-title">
            <SiLeetcode /> LeetCode Badges
            {lcBadges.length > 0 && (
              <span className="count-pill">{lcCount}</span>
            )}
          </h2>
          <a
            className="see-all"
            href={profileUrl}
            target="_blank"
            rel="noreferrer"
          >
            Profile <FiExternalLink />
          </a>
        </div>

        {loading && lcBadges.length === 0 ? (
          <div className="lc-badges-grid">
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} className="lc-badge-skeleton skeleton-shimmer" />
            ))}
          </div>
        ) : error && lcBadges.length === 0 ? (
          <div className="empty-state">
            Couldn&apos;t load LeetCode badges right now.{" "}
            <a href={profileUrl} target="_blank" rel="noreferrer">
              View them on LeetCode
            </a>
            .
          </div>
        ) : (
          <div className="lc-badges-grid">
            {lcBadges.map((b) => (
              <LeetCodeBadge key={b.id || b.displayName} badge={b} />
            ))}
          </div>
        )}
      </section>

      <section className="certificates-section">
        <div className="section-head">
          <h2 className="section-title">
            <FiAward /> Certificates
            <span className="count-pill">{certificates.length}</span>
          </h2>
        </div>
        <div className="badges-grid">
          {certificates.map((badge) => (
            <BadgeCard key={badge.slug} badge={badge} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Badges;
